/**
 *
 * @param {*} time 时间戳
 * @param {*} format 格式化的时间格式
 * @returns
 */
const formatDate = (time = 0, format) => {
  const date = new Date(time);
  const map = {
    y: date.getFullYear(),
    M: date.getMonth() + 1, // month
    d: date.getDate(), // date
    H: date.getHours(), // hours
    m: date.getMinutes(), // minutes
    s: date.getSeconds(), // seconds
  };
  for (const i in map) {
    if (map.hasOwnProperty(i)) {
      if (map[i] < 10) {
        map[i] = '0' + map[i];
      }
    }
  }
  const formatParam = format || 'yyyy-MM-dd HH:mm:ss';
  const reg = new RegExp('y+|M+|d+|H+|m+|s+', 'g');
  const regY = new RegExp('y');
  const formatResult = formatParam.replace(reg, (v) => {
    let old = v;
    if (regY.test(v)) {
      const year = '' + map.y;
      const len = 4 - v.length;
      old = year.substr(len);
    } else {
      const key = v.substr(0, 1);
      old = map[key];
    }
    return old;
  });
  return formatResult;
};
export default formatDate;
